import React, { useState, useEffect, useContext } from 'react';
import { Box, Stack, Paper, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import StyledTableRow from '../shared/components/styledTableRow';
import StyledTableCell from '../shared/components/styledTableCell';
import ServiceSearchHeader from './serviceSearchHeader';
import ServiceMenuPopup from './serviceMenuPopup';
import { HomeContext } from '../utils/contexts/homeContext';
import { PatientSearchAPIUrl, GetDateOnlyStringValue, GetDayJSValueFromUTCDate, GetNoToCurrencyFormat } from '../utils/extensions/functionEx';
import PageLoading from '../shared/components/backdrop';
import { ServiceNurseStatus } from '../utils/extensions/constantEx';
import dayjs from 'dayjs';
import { useCookies } from 'react-cookie';

export default function ServiceSearch() {

    const { ShowAPIError, OpenErrorAlert, SetPatientServiceSearchText, homeState, ClearLoggedUser } = useContext(HomeContext);

    const [dbPatientServices, setDbPatientServices] = useState([]);
    const [isOpenPageLoad, setIsOpenPageLoad] = useState(false);

    const [cookies, setCookie] = useCookies(['hplus_home_care_user_session_code']);

    useEffect(() => {
        async function fetchPatientServices() {
            searchPatientServices(homeState.patientServiceSearchText.length > 0 ? homeState.patientServiceSearchText : '');
        }
        fetchPatientServices();
    }, []);

    const searchPatientServices = async (searchText) => {
        try {
            setIsOpenPageLoad(true);
            SetPatientServiceSearchText(searchText);

            let tempServices = [];
            const headers = new Headers();
            headers.append("Hc-App-Auth-Token", cookies.hplus_home_care_user_session_code);
            const response = await fetch(PatientSearchAPIUrl(homeState.loggedUser.companyCode, searchText), { headers });
            if (response.status === 401) {
                OpenErrorAlert('User login history expired, please log in again.');
                setCookie('hplus_home_care_user_session_code', '', { path: '/' });
                ClearLoggedUser();
            } else if (response.status === 200) {
                tempServices = await response.json();
            } else {
                ShowAPIError(response)
            }
            setDbPatientServices([...tempServices]);
        }
        catch (error) {
            OpenErrorAlert(error)
        } finally {
            setIsOpenPageLoad(false);
        }
    }

    const handleSearchClick = (searchText) => {
        searchPatientServices(searchText.trim());
    }

    const handlePageLoadingClose = () => {
        setIsOpenPageLoad(false);
    }

    const getTableCellStayle = (serviceNurseStatusId, nurseStartDate, nurseDutDays) => {
        let foreColor = 'black';

        if (serviceNurseStatusId == ServiceNurseStatus.Active) {
            let tempDate = GetDayJSValueFromUTCDate(nurseStartDate);
            const tempStartDate = dayjs(tempDate.year().toString() + '-' + (tempDate.month() + 1).toString() + '-' + tempDate.date().toString());

            tempDate = tempStartDate.add(parseInt(nurseDutDays) - 1, 'day');
            const tempEndDate = dayjs(tempDate.year().toString() + '-' + (tempDate.month() + 1).toString() + '-' + tempDate.date().toString());

            const tmpEndDay = tempEndDate.diff(tempStartDate, 'day') + 1;
            foreColor = tmpEndDay <= 7 ? 'red' : 'blue';
        }
        return {
            "color": foreColor
        };
    }


    return (
        <Box sx={{ bgcolor: '#cfe8fc', padding: '8px, 0' }}>
            <Stack spacing={0}>
                {
                    isOpenPageLoad &&
                    <PageLoading isOpenPageLoading={isOpenPageLoad} handleClose={handlePageLoadingClose} />
                }
                <ServiceSearchHeader handleServiceSearchClick={handleSearchClick} />
                <TableContainer component={Paper} sx={{ maxHeight: `calc(100vh - 185px)`, borderRadius: '0' }}>
                    <Table stickyHeader sx={{ minWidth: 700, width: '2930px', overflowX: 'auto' }}>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center" sx={{ width: '55px' }}></StyledTableCell>
                                <StyledTableCell sx={{ width: '150px' }}>Duty</StyledTableCell>
                                <StyledTableCell sx={{ width: '200px' }}>Nurse</StyledTableCell>
                                <StyledTableCell sx={{ width: '70px' }}>Duty Days</StyledTableCell>
                                <StyledTableCell sx={{ width: '100px' }}>Start Date</StyledTableCell>
                                <StyledTableCell sx={{ width: '100px' }}>End Date</StyledTableCell>
                                <StyledTableCell sx={{ width: '100px' }}>Completed Days</StyledTableCell>
                                <StyledTableCell sx={{ width: '100px' }}>Completed Date</StyledTableCell>
                                <StyledTableCell sx={{ width: '100px' }}>Salary</StyledTableCell>
                                <StyledTableCell sx={{ width: '100px' }}>Paid</StyledTableCell>
                                <StyledTableCell sx={{ width: '100px' }}>Balance</StyledTableCell>
                                <StyledTableCell sx={{ width: '220px' }}>Patient</StyledTableCell>
                                <StyledTableCell sx={{ width: '190px' }}>Place</StyledTableCell>
                                <StyledTableCell sx={{ width: '200px' }}>Nurse Phone</StyledTableCell>
                                <StyledTableCell sx={{ width: '200px' }}>Patient Phone</StyledTableCell>
                                {/* <StyledTableCell sx={{ width: '140px' }}>Receipt Nos</StyledTableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dbPatientServices.map((dbPatientService) => (
                                <StyledTableRow key={dbPatientService.service_nurse_id.toString()}>
                                    <StyledTableCell align="center">
                                        <ServiceMenuPopup selectedRow={dbPatientService} />
                                    </StyledTableCell>
                                    <StyledTableCell sx={getTableCellStayle(dbPatientService.service_nurse_status_id, dbPatientService.nurse_start_date, dbPatientService.nurse_duty_days)}>
                                        {dbPatientService.service_type_name}
                                    </StyledTableCell>
                                    <StyledTableCell sx={getTableCellStayle(dbPatientService.service_nurse_status_id, dbPatientService.nurse_start_date, dbPatientService.nurse_duty_days)}>
                                        {dbPatientService.nurse_name}
                                    </StyledTableCell>
                                    <StyledTableCell sx={getTableCellStayle(dbPatientService.service_nurse_status_id, dbPatientService.nurse_start_date, dbPatientService.nurse_duty_days)}>
                                        {dbPatientService.nurse_duty_days}
                                    </StyledTableCell>
                                    <StyledTableCell sx={getTableCellStayle(dbPatientService.service_nurse_status_id, dbPatientService.nurse_start_date, dbPatientService.nurse_duty_days)}>
                                        {GetDateOnlyStringValue(GetDayJSValueFromUTCDate(dbPatientService.nurse_start_date))}
                                    </StyledTableCell>
                                    <StyledTableCell sx={getTableCellStayle(dbPatientService.service_nurse_status_id, dbPatientService.nurse_start_date, dbPatientService.nurse_duty_days)}>
                                        {GetDateOnlyStringValue(GetDayJSValueFromUTCDate(dbPatientService.nurse_end_date))}
                                    </StyledTableCell>
                                    <StyledTableCell sx={getTableCellStayle(dbPatientService.service_nurse_status_id, dbPatientService.nurse_start_date, dbPatientService.nurse_duty_days)}>
                                        {dbPatientService.nurse_completed_days}
                                    </StyledTableCell>
                                    <StyledTableCell sx={getTableCellStayle(dbPatientService.service_nurse_status_id, dbPatientService.nurse_start_date, dbPatientService.nurse_duty_days)}>{
                                        dbPatientService.service_nurse_status_id !== ServiceNurseStatus.Active ?
                                            GetDateOnlyStringValue(GetDayJSValueFromUTCDate(dbPatientService.nurse_completed_date))
                                            : ''}</StyledTableCell>
                                    <StyledTableCell sx={getTableCellStayle(dbPatientService.service_nurse_status_id, dbPatientService.nurse_start_date, dbPatientService.nurse_duty_days)}>
                                        {GetNoToCurrencyFormat(dbPatientService.service_fee)}
                                    </StyledTableCell>
                                    <StyledTableCell sx={getTableCellStayle(dbPatientService.service_nurse_status_id, dbPatientService.nurse_start_date, dbPatientService.nurse_duty_days)}>
                                        {GetNoToCurrencyFormat(dbPatientService.service_paid_fee)}
                                    </StyledTableCell>
                                    <StyledTableCell sx={getTableCellStayle(dbPatientService.service_nurse_status_id, dbPatientService.nurse_start_date, dbPatientService.nurse_duty_days)}>
                                        {GetNoToCurrencyFormat(dbPatientService.service_balance_fee)}
                                    </StyledTableCell>
                                    <StyledTableCell sx={getTableCellStayle(dbPatientService.service_nurse_status_id, dbPatientService.nurse_start_date, dbPatientService.nurse_duty_days)}>
                                        {dbPatientService.patient_name}
                                    </StyledTableCell>
                                    <StyledTableCell sx={getTableCellStayle(dbPatientService.service_nurse_status_id, dbPatientService.nurse_start_date, dbPatientService.nurse_duty_days)}>
                                        {dbPatientService.place}
                                    </StyledTableCell>
                                    <StyledTableCell sx={getTableCellStayle(dbPatientService.service_nurse_status_id, dbPatientService.nurse_start_date, dbPatientService.nurse_duty_days)}>
                                        {dbPatientService.nurse_phone}
                                    </StyledTableCell>
                                    <StyledTableCell sx={getTableCellStayle(dbPatientService.service_nurse_status_id, dbPatientService.nurse_start_date, dbPatientService.nurse_duty_days)}>
                                        {dbPatientService.patient_phone}
                                    </StyledTableCell>
                                    {/* <StyledTableCell sx={getTableCellStayle(dbPatientService.service_nurse_status_id, dbPatientService.nurse_start_date, dbPatientService.nurse_duty_days)}>
                                        {dbPatientService.receipt_nos}
                                    </StyledTableCell> */}
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Stack>
        </Box>
    );
}